import { useContext } from 'react';
import AlertContext from './AlertContext.js';

const useAlert = () => useContext(AlertContext);

export default useAlert;